import React from 'react';
import { Grid } from '@material-ui/core';
import { showReportDialog } from '@sentry/browser';
import EmptyState from '%app/js/common/components/material/EmptyState';
import Translator from '%app/js/common/services/translator';
import useTranslationsSettled from '%app/js/common/components/translation/useTranslationsSettled';
import LocalizationStorage from '%app/js/common/services/localizationStorage';
import errorIcon from '%evp_theme/img/virus.svg';
import currentUserSettingsProvider from '%paysera_admin_frontend/js/common/service/currentUserSettingsProvider';

const ERROR_TRANSLATION_DOMAINS = ['PayseraAdminBundle'];

function Error() {
    const translationsSettled = useTranslationsSettled(ERROR_TRANSLATION_DOMAINS);

    if (!translationsSettled) {
        return null;
    }

    const dialogConfig = {
        lang: LocalizationStorage.getCurrentLanguage(),
        title: Translator.trans('error_boundary.sentry_dialog.title'),
        subtitle: Translator.trans('error_boundary.sentry_dialog.subtitle'),
        subtitle2: Translator.trans('error_boundary.sentry_dialog.subtitle2'),
        labelName: Translator.trans('error_boundary.sentry_dialog.name_label'),
        labelEmail: Translator.trans('error_boundary.sentry_dialog.email_label'),
        labelComments: Translator.trans('error_boundary.sentry_dialog.comments_label'),
        labelClose: Translator.trans('error_boundary.sentry_dialog.close_label'),
        labelSubmit: Translator.trans('error_boundary.sentry_dialog.submit_label'),
        errorGeneric: Translator.trans('error_boundary.sentry_dialog.generic_error'),
        errorFormEntry: Translator.trans('error_boundary.sentry_dialog.entry_error'),
        successMessage: Translator.trans('error_boundary.sentry_dialog.success'),
        user: {
            email: currentUserSettingsProvider.get('email'),
            name: currentUserSettingsProvider.getUserShortName(),
        },
    };

    return (
        <Grid container>
            <EmptyState
                headline={Translator.trans('error_boundary.error_headline')}
                subheading={Translator.trans('error_boundary.error_subheading')}
                image={errorIcon}
                buttonText={Translator.trans('error_boundary.give_info')}
                buttonAction={() => showReportDialog(dialogConfig)}
                secondaryButtonText={Translator.trans('error_boundary.refresh_page')}
                secondaryButtonAction={() => window.location.reload()}
            />
        </Grid>
    );
}

export default React.memo(Error);
